export default __webpack_public_path__ + "static/media/chart-background.94b5f59a.png";